<template>
  <div class="header-wrap">
    <div class="header">
      <div class="logo-wrap">
        <img src="../assets/img/logo.png" alt="" />
      </div>
      <div class="menu-icon" id="menu-btn">
        <div class="menu-i"></div>
        <div class="menu-i"></div>
        <div class="menu-i"></div>
      </div>
    </div>
    <div id="menu">
      <div class="f1">
        <ul>
          <li><router-link to="/" @click.native="refresh">首页</router-link></li>
          <li>
            <router-link to="/about" @click.native="refresh">走进大吕</router-link>
            <div class="f2">
              <ul>
                <li>
                  <img src="../assets/img/icon_us.png" alt="" srcset="" />
                  <router-link to="/about" @click.native="refresh">关于我们</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_new.png" alt="" srcset="" />
                  <router-link to="/news" @click.native="refresh">新闻资讯</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_cp.png" alt="" srcset="" />
                  <router-link to="/contact" @click.native="refresh">商务合作</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_public.png" alt="" srcset="" />
                  <router-link to="/welfare" @click.native="refresh">社会公益</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li><router-link to="/nbaip" @click.native="refresh">NBA IP联名</router-link></li>
          <li>
            <router-link to="/channel" @click.native="refresh">数字营销</router-link>
            <div class="f2">
              <ul>
                <li>
                  <img src="../assets/img/icon_ad.png" alt="" srcset="" />
                  <router-link to="/channel" @click.native="refresh">互联网广告投放</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_online.png" alt="" srcset="" />
                  <router-link to="/broadcast" @click.native="refresh">社交电商服务</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <router-link to="/digitalcontent" @click.native="refresh">数字内容</router-link>
            <div class="f2">
              <ul>
                <li>
                  <img src="../assets/img/icon_digital.png" alt="" srcset="" />
                  <router-link to="/digitalcontent" @click.native="refresh">数字内容</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_kol.png" alt="" srcset="" />
                  <router-link to="/kol" @click.native="refresh">游戏数字传播</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_nba.png" alt="" srcset="" />
                  <router-link to="/nba" @click.native="refresh">篮球数字传播</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li><router-link to="/game" @click.native="refresh">游戏发行</router-link></li>
          <li><router-link to="/read" @click.native="refresh">内容出版</router-link></li>
          <li>
            <router-link to="/join" @click.native="refresh">加入我们</router-link>
            <div class="f2">
              <ul>
                <li>
                  <img src="../assets/img/icon_join.png" alt="" srcset="" />
                  <router-link to="/join" @click.native="refresh">加入我们</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_sojoin.png" alt="" srcset="" />
                  <router-link to="/join/1" @click.native="refresh">社会招聘</router-link>
                </li>
                <li>
                  <img src="../assets/img/icon_scjoin.png" alt="" srcset="" />
                  <router-link to="/join/2" @click.native="refresh">校园招聘</router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Header",
  data() {
    return {
      navBar: false,
    };
  },
  mounted() {
    $("#menu")
      .leftMenu({
        triggerBtn: "#menu-btn",
      })
      .init();

  },
  methods: {
    refresh:function(){
      document.location.reload();
    }
  },
};
</script>

<style lang="scss">

.header-wrap{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 666666;
}
.header {
  padding: 0% 5%;
  display: flex;
  justify-content: space-between;
  background-color: rgb(178,41,41) !important;
  > .logo-wrap {
    width: 30%;
    padding: 20px 0 15px 0;
    > img {
      width: 100%;
    }
  }
  .menu-icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    > .menu-i {
      width: 1.5rem;
      height: 0.2rem;
      border-radius: 0.2rem;
      background-color: #fff;
      &:nth-of-type(2) {
        margin: 0.3rem 0;
      }
    }
  }
}

.nav-box {
  position: fixed;
  left: 15%;
  width: 85%;
  top: 0px;
  z-index: 666;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue